import React, { useCallback, useEffect, useState } from "react";
import uiConfig from "../config/uiConfig";

import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Badge,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";


import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PeopleIcon from "@mui/icons-material/People";
import TimelineIcon from "@mui/icons-material/Timeline";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

import NotificationsDrawer from "../components/notifications/NotificationsDrawer";
import { getUnreadCount } from "../services/notificationService";
import { useUserRole } from "../context/UserRoleContext";
import { canAccessPage } from "../auth/roles";


const userMenuItems = [
  {
    text: "Projects",
    icon: <AccountTreeIcon fontSize="small" />,
    path: "/projects",
    pageKey: "projects",
  },
  {
    text: "Reports",
    icon: <AssessmentIcon fontSize="small" />,
    path: "/reports",
    pageKey: "reports",
  },
  {
    text: "Departments",
    icon: <ApartmentIcon fontSize="small" />,
    path: "/departments",
    pageKey: "departments",
  },
  {
    text: "Employees",
    icon: <PeopleIcon fontSize="small" />,
    path: "/employees",
    pageKey: "employees",
  },
  {
    text: "Resource Mgmt",
    icon: <TimelineIcon fontSize="small" />,
    path: "/resource-management",
    pageKey: "resource_management",
  },
];


function Header({
  drawerWidth,
  handleDrawerToggle,
  isSidebarCollapsed,
  onToggleSidebarCollapse,
}) {

  const { accounts, instance } = useMsal();
  const { employee, role } = useUserRole();
  const navigate = useNavigate();

  const account = accounts?.[0];
  const userName = account?.name || "Guest User";
  const userEmail = account?.username || "";

  const initials = userName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "GU";

  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  const visibleUserMenuItems = userMenuItems.filter((item) => canAccessPage(role, item.pageKey));

  const handleUserMenuItemClick = (path) => {
    setUserMenuAnchor(null);
    navigate(path);
  };

  const handleLogout = () => {
    setUserMenuAnchor(null);
    instance.logoutRedirect();
  };

  const employeeId = employee?.employee_id;

  const refreshUnreadCount = useCallback(async () => {
    if (!employeeId) {
      return;
    }

    try {
      const count = await getUnreadCount(employeeId);
      setUnreadCount(count);
    } catch (error) {
      console.error("Unread Count Error:", error);
    }
  }, [employeeId]);

  useEffect(() => {
    refreshUnreadCount();

    const interval = setInterval(refreshUnreadCount, 30000);
    return () => clearInterval(interval);
  }, [refreshUnreadCount]);

  const handleUnreadCountChange = (updater) => {
    setUnreadCount((prev) => (typeof updater === "function" ? updater(prev) : updater));
  };


  return (
    <>
    <AppBar

      position="fixed"

      elevation={0}

      sx={{

        width: {
          sm: `calc(100% - ${drawerWidth}px)`
        },

        ml: {
          sm: `${drawerWidth}px`
        },

        bgcolor: "#ffffff",

        color: "#111827",

        borderBottom: "1px solid #e5e7eb",

        boxShadow: "0 2px 8px rgba(0,0,0,0.04)"

      }}

    >



      <Toolbar

        sx={{

          height: 78,

          px: 4,

          display: "flex",

          alignItems: "center",

          justifyContent: "space-between"

        }}

      >





        {/* Mobile Menu */}
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              display: {
                xs: "flex",
                sm: "none"
              }
            }}
          >
            <MenuIcon />
          </IconButton>

          <Tooltip title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}>
            <IconButton
              onClick={onToggleSidebarCollapse}
              sx={{
                display: {
                  xs: "none",
                  sm: "flex"
                }
              }}
            >
              <MenuOpenIcon
                sx={{
                  color: "#64748b",
                  transform: isSidebarCollapsed ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease"
                }}
              />
            </IconButton>
          </Tooltip>

           <Typography

          variant="h6"

          sx={{

            fontWeight: 800,

            fontSize: "22px",

            letterSpacing: "0.3px",

            color: "#111827"

          }}

        >

          IT SERVICE DESK PORTAL


        </Typography>
        </Box>







        {/* Heading */}


       








        {/* Right Section */}


        <Box

          display="flex"

          alignItems="center"

          gap={2.5}

        >






          {/* Notifications */}


          <Tooltip title="Notifications">


            <IconButton onClick={() => setNotificationsOpen(true)}>


              <Badge

                badgeContent={unreadCount}

                color="error"

              >


                <NotificationsNoneIcon

                  sx={{

                    color: "#64748b",

                    fontSize: 27

                  }}

                />


              </Badge>


            </IconButton>


          </Tooltip>










          {/* Settings */}


          <Tooltip title="Settings">


            <IconButton>


              <SettingsOutlinedIcon

                sx={{

                  color: "#64748b",

                  fontSize: 26

                }}

              />


            </IconButton>


          </Tooltip>









          {/* User */}


          <Box

            display="flex"

            alignItems="center"

            gap={1.5}

            ml={1}

          >


            <Box

              onClick={(event) => setUserMenuAnchor(event.currentTarget)}

              data-testid="user-menu-trigger"

              sx={{

                display: "flex",

                alignItems: "center",

                gap: 0.3,

                cursor: "pointer"

              }}

            >

              <Avatar

                src={employee?.profile_picture || undefined}

                sx={{

                  background: uiConfig.tableAccentGradient,

                  width: 35,

                  height: 35,

                  fontWeight: 600

                }}

              >

                <span style={{ fontSize: "14px" }}>{initials}</span>


              </Avatar>

              <IconButton size="small" sx={{ p: 0.3 }}>

                <KeyboardArrowDownIcon

                  sx={{

                    color: "#64748b",

                    fontSize: 22,

                    transition: "transform 0.2s ease",

                    transform: userMenuAnchor ? "rotate(180deg)" : "rotate(0deg)"

                  }}

                />

              </IconButton>

            </Box>


            <Menu

              anchorEl={userMenuAnchor}

              open={Boolean(userMenuAnchor)}

              onClose={() => setUserMenuAnchor(null)}

              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}

              transformOrigin={{ vertical: "top", horizontal: "right" }}

              data-testid="user-menu-dropdown"

              slotProps={{

                paper: {

                  sx: {

                    width: 260,

                    borderRadius: 2,

                    border: "1px solid #e2e8f0",

                    boxShadow: "0 10px 30px rgba(15,23,42,0.12)",

                    mt: 1

                  }

                }

              }}

            >

              <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #f1f5f9" }}>

                <Box display="flex" alignItems="center" gap={1.5}>

                  <Avatar

                    src={employee?.profile_picture || undefined}

                    sx={{

                      background: uiConfig.tableAccentGradient,

                      width: 36,

                      height: 36,

                      fontWeight: 600,

                      fontSize: 13

                    }}

                  >

                    {initials}

                  </Avatar>

                  <Box sx={{ minWidth: 0, flex: 1 }}>

                    <Typography

                      data-testid="user-name"

                      noWrap

                      sx={{ fontSize: 14, fontWeight: 600, color: "#0f172a" }}

                    >

                      {userName}

                    </Typography>

                    <Typography

                      data-testid="user-email"

                      noWrap

                      sx={{ fontSize: 12, color: "#64748b" }}

                    >

                      {userEmail}

                    </Typography>

                  </Box>

                </Box>

              </Box>

              {visibleUserMenuItems.length > 0 && [

                <Box key="user-menu-items" sx={{ py: 0.5, borderBottom: "1px solid #f1f5f9" }}>

                  {visibleUserMenuItems.map((item) => (

                    <MenuItem

                      key={item.path}

                      data-testid={`nav-link-${item.text.toLowerCase()}`}

                      onClick={() => handleUserMenuItemClick(item.path)}

                      sx={{

                        py: 1,

                        "&:hover": { background: uiConfig.headerMenuHoverColor }

                      }}

                    >

                      <ListItemIcon sx={{ color: "#64748b", minWidth: 32 }}>

                        {item.icon}

                      </ListItemIcon>

                      <ListItemText

                        primaryTypographyProps={{ fontSize: 14, color: "#334155" }}

                      >

                        {item.text}

                      </ListItemText>

                    </MenuItem>

                  ))}

                </Box>

              ]}

              <MenuItem

                onClick={handleLogout}

                data-testid="logout-button"

                sx={{

                  py: 1,

                  "&:hover": { background: uiConfig.headerMenuHoverColor }

                }}

              >

                <ListItemIcon sx={{ color: "#64748b", minWidth: 32 }}>

                  <LogoutIcon fontSize="small" />

                </ListItemIcon>

                <ListItemText

                  primaryTypographyProps={{ fontSize: 14, color: "#334155" }}

                >

                  Sign out

                </ListItemText>

              </MenuItem>

            </Menu>


          </Box>





        </Box>





      </Toolbar>


    </AppBar>

    <NotificationsDrawer
      open={notificationsOpen}
      onClose={() => setNotificationsOpen(false)}
      employeeId={employeeId}
      onUnreadCountChange={handleUnreadCountChange}
    />
    </>
  );

}



export default Header;